export default {
  downtimeUrl: "https://www.kodland.org",
  parameters: {
    landing_id: "MyQGen",
    segment: 51,
  },
  startPage: {
    title: "Jawab 5 soalan dan dapatkan kelas PERCUMA untuk anak anda",
    button: " Terima 🚀 ",
    image: {
      url: "/welcome/my_base2_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/my_base2_mob.png",
      style: {
        width: "100%",
      },
    },
  },
  successPage: {
    title: "Pilih tarikh dan masa untuk mendapatkan kelas PERCUMA 🚀",
    subtitle: "Klik butang “📆 Tempah” dan dapatkan pelajaran.",
    button: "📆 Tempah"
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title: "Terima kasih kerana mempercayai platform pendidikan kami! Malangnya, tablet atau telefon tidak sesuai untuk mengikuti kelas kami. Kami berbesar hati untuk berjumpa anda di kelas kami pada masa akan datang!",
  },
  quizRotateBySteps: {
    1: {
      question: "Bagaimana anak anda biasa mengisi masa lapangnya?",
      answers: [
        "📱 Bermain permainan di telefon atau komputer",
        "👽 Menonton kartun",
        "😌 Meluangkan masa dengan ahli keluarga",
        "👥 Meluangkan masa dengan rakan-rakan",
        "🎨 Melakukan aktiviti seni: melukis, muzik, lakonan, dll.",
      ],
    },
    2: {
      question: "Adakah anak anda menyertai aktiviti kokurikulum di luar pembelajaran sekolah?",
      answers: [
        "📚 Kelas yang membantu meningkatkan prestasi akademik",
        "⛹️ Ya. Aktiviti sukan",
        "🎨 Ya. Kelas Seni",
        "💻 Ya. Kelas pengaturcaraan dan sains komputer",
        "🏕️ Ya. Pengakap",
        "✖️ Tidak. Anak tidak mempunyai masa untuk itu",
      ],
    },
    3: {
      question:
        "Adakah anda mempunyai komputer desktop atau komputer riba untuk anak anda belajar?",
      answers: [
        "👍 Ya",
        {
          answer: "👎 Tidak",
          stopAnswer: true,
        },
      ],
    },
  },
};
